import type { BestConditionsSummary } from '@/types/patterns';

const TIME_PERIOD_LABELS = {
  morning: 'Morning hunts',
  midday: 'Midday hunts',
  evening: 'Evening hunts',
} as const;

const PRESSURE_ICONS = {
  rising: '⬆',
  falling: '⬇',
  steady: '➡',
} as const;

interface BestConditionsInsightProps {
  summary: BestConditionsSummary;
}

export function BestConditionsInsight({ summary }: BestConditionsInsightProps) {
  const {
    avgTemperature,
    dominantPressureTrend,
    dominantWindDirection,
    avgWindSpeed,
    totalObservationEntries,
    bestTimePeriod,
  } = summary;

  return (
    <div
      className="bg-[var(--color-surface)] border border-[var(--color-border)] rounded-lg p-3"
      data-testid="best-conditions-insight"
    >
      <p className="field-label mb-2">
        Best Observation Conditions
      </p>
      <p className="text-body-sm text-[var(--color-text-muted)] mb-2">
        Your best days for deer sightings:
      </p>
      <div className="flex flex-wrap gap-1.5 mb-2">
        <span className="bg-[var(--color-elevated)] text-[var(--color-text-muted)] text-body-xs px-2 py-0.5 rounded">
          🌡 Avg {avgTemperature}°F
        </span>
        <span className="bg-[var(--color-elevated)] text-[var(--color-text-muted)] text-body-xs px-2 py-0.5 rounded">
          {PRESSURE_ICONS[dominantPressureTrend]} Pressure {dominantPressureTrend}
        </span>
        {dominantWindDirection !== 'variable' && (
          <span className="bg-[var(--color-elevated)] text-[var(--color-text-muted)] text-body-xs px-2 py-0.5 rounded">
            💨 {dominantWindDirection} {avgWindSpeed}mph
          </span>
        )}
        <span className="bg-[var(--color-elevated)] text-[var(--color-text-muted)] text-body-xs px-2 py-0.5 rounded">
          🌅 {TIME_PERIOD_LABELS[bestTimePeriod]}
        </span>
      </div>
      <p className="text-body-xs text-[var(--color-text-placeholder)]" data-testid="sample-size">
        Based on {totalObservationEntries} observation {totalObservationEntries === 1 ? 'entry' : 'entries'}
      </p>
    </div>
  );
}
